import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Button } from '../../interfaces/button.interface';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
  standalone: false,
})
export class DialogComponent implements OnInit {
  title = '';
  titleText = '';
  body = '';
  bodyLines: string[] = [];
  buttons: Button[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<DialogComponent>
  ) {}

  ngOnInit(): void {
    if (this.data) {
      if (this.data?.title) {
        this.title = this.data.title;
      }
      if (this.data?.titleText) {
        this.titleText = this.data.titleText;
      }
      if (this.data?.body) {
        this.body = this.data.body;
      }
      if (this.data?.bodyLines?.length) {
        this.bodyLines = this.data.bodyLines;
      }
      if (this.data?.buttons) {
        this.buttons = this.data.buttons;
      }
    }
  }
  doAction(action) {
    this.dialogRef.close(action);
  }
}
